import { Link } from "react-router-dom";
import Hero from "../components/Hero";
import NowPlaying from "../components/homepage-components/NowPlaying";
import RecentUploads from "../components/homepage-components/RecentUploads";
import ProjectKBanner from "../components/homepage-components/ProjectKBanner"; // <-- import here
import BookSection from "../components/homepage-components/BookSection";

export default function Home() {
  return (
    <>
      {/* HERO SECTION */}
      <Hero
        title="George Sotirov"
        subtitle="Motion Graphic Designer"
        mediaType="video"
        mediaSrc="../assets/hero-video-particles.webm"
      >
        <div className="hero-buttons">
          <Link to="/personal" className="hero-button-primary">
            Personal
          </Link>
          <Link to="/portfolio" className="hero-button-secondary">
            Portfolio
          </Link>
        </div>
      </Hero>

      {/* CONTAINER CLASS IS FOR MAX WIDTH */}
      <div className="container">
        <NowPlaying />
        <RecentUploads />
      </div>
      <ProjectKBanner
        headline={"Project K"}
        subheading={"Let it burn, let it burn. Watch it all fall."}
        buttonText={"Learn more"}
        backgroundImage={"/assets/Images/Home/Project_K_Banner.webp"}
      />
      <div className="container">
        <BookSection />
      </div>
    </>
  );
}
